module.exports = __webpack_public_path__ + "img/IT0000103420796.4cb717ac.png";